import React from 'react';
import styled from 'styled-components';

const HeaderEntityContainer = styled.div`
  font-size: 22px;
  color: var(--formHdrHeading);
  font-weight: 400;
  display: flex;
  min-height: 22px;
  letter-spacing: -0.5px;
  flex-wrap: wrap;
`;
export default HeaderEntityContainer;
